/* eslint-disable */
import request from '@/utils/request'
const qs = require('qs')
export function checkSubdomainMulti(data) {
    return request({
        url: '/auth/my_admin/check_subdomain',
        method: 'POST',
        data: qs.stringify(data) // untuk array data post
    })
}

export function loginMulti(data) {
  return request({
    url: '/auth/my_admin/login',
    method: 'POST',
    data,
    transformRequest: [
      function(data) {
        const serializedData = []
        for (const k in data) {
          if (data[k]) {
            serializedData.push(`${k}=${encodeURIComponent(data[k])}`)
          }
        }

        return serializedData.join('&')
      }
    ]
  })
}


// WEBPACK FOOTER //
// ./src/api/userMulti.js